import { DEFAULT_NANDOS_PHONE } from '@nandosaus/constants';
import { isEmpty } from 'lodash';
import { observer } from 'mobx-react';
import { restaurantPropTypes } from '@nandosaus/prop-types';
import React from 'react';

import { RestaurantStatus } from '@components/restaurant-status';
import { useFeature } from '@hooks/use-feature';
import { Col, Flex } from '../grid';
import { Link } from '../link';
import { P } from '../typography';
import { RestaurantDetail } from './restaurant-detail';

const RestaurantInformationHeader = observer(({ restaurant }) => {
  const { formattedAddress, isOpenText, phone } = restaurant;
  const hasRestaurantFacilities = !isEmpty(restaurant.formattedFacilities);
  const showCmsRestaurantPages = useFeature('show-cms-restaurant-pages');

  const phoneNumber = phone || DEFAULT_NANDOS_PHONE;
  const sectionPadding = { xs: '1.5rem', md: '1rem' };
  const detailPadding = { xs: '1rem', md: '.5rem' };
  const encodedLink = encodeURI(`https://maps.google.com/?q=Nando\u2019s ${restaurant.name}, ${formattedAddress}`);

  return (
    <Col width={{ xs: 1, md: 6 / 12 }} pt="1rem">
      <Flex pb={sectionPadding}>
        <P fontWeight="bold">Directions</P>
      </Flex>
      <Flex>
        <RestaurantDetail iconName="locationMarker" detailText={formattedAddress} />
      </Flex>
      <Flex>
        <Link
          fontWeight="normal"
          pl={{ xs: '2.5rem', md: '2rem', lg: '2rem', xl: '1.5rem' }}
          href={encodedLink}
          py=".5rem"
          target="_blank"
        >
          Get Directions
        </Link>
      </Flex>
      <Flex pb={detailPadding}>
        <RestaurantDetail iconName="phone" detailText={phoneNumber} />
      </Flex>
      {!showCmsRestaurantPages && (
        <Flex pb={detailPadding}>
          {isOpenText && <RestaurantStatus restaurant={restaurant} showClosestRestaurant />}
        </Flex>
      )}
      {hasRestaurantFacilities && (
        <>
          <Flex mt={1} py={sectionPadding}>
            <P fontWeight="bold">Facilities</P>
          </Flex>

          {restaurant.formattedFacilities.map(key => (
            <Flex pb={detailPadding}>
              <RestaurantDetail iconName="tick" detailText={key} />
            </Flex>
          ))}
        </>
      )}
    </Col>
  );
});

RestaurantInformationHeader.propTypes = {
  restaurant: restaurantPropTypes.isRequired,
};

export { RestaurantInformationHeader };
